import { render, staticRenderFns } from "./DialogTaoPhieuThayDoiThongTin.vue?vue&type=template&id=5b385162&scoped=true&"
import script from "./DialogTaoPhieuThayDoiThongTin.vue?vue&type=script&lang=js&"
export * from "./DialogTaoPhieuThayDoiThongTin.vue?vue&type=script&lang=js&"
import style0 from "./DialogTaoPhieuThayDoiThongTin.vue?vue&type=style&index=0&id=5b385162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b385162",
  null
  
)

export default component.exports